export default __webpack_public_path__ + "static/media/landing-banner.98fce7a5.jpg";